<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
    <div class="container-fluid">
      <menu-logo></menu-logo>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav gap-lg-1">
          <menu-item
            v-if="canAccessSoporteComputed"
            ruta="soporte"
            :es-activo="activeMenu === 'soporte'"
            icon-css="fa-regular fa-headset"
            :texto="intl.i18n.t('menu.item.soporte')"
            @click="setActiveMenu('soporte')"
          >
          </menu-item>
          <menu-dropdown
            v-if="canAccessFacturasComputed"
            icon-css="fa-regular fa-file-lines"
            :es-activo="activeMenu === 'facturas'"
            :texto="intl.i18n.t('menu.item.facturas')"
            @click="setActiveMenu('facturas')"
            @update-activo="activeMenu = 'facturas'"
          >
            <menu-dropdown-item
              ruta="facturas/colaboradores"
              :texto="intl.i18n.t('menu.item.facturas_colaboradores')"
            />
            <menu-dropdown-item
              ruta="facturas/processus"
              :texto="intl.i18n.t('menu.item.facturas_processus')"
            />
          </menu-dropdown>
          <menu-dropdown
            v-if="canAccessEmpresasServiciosComputed"
            icon-css="fa-regular fa-list-ul"
            :es-activo="activeMenu === 'servicios'"
            :texto="intl.i18n.t('menu.item.servicios')"
            @click="setActiveMenu('servicios')"
            @update-activo="activeMenu = 'servicios'"
          >
            <menu-dropdown-item
              v-for="tipoServicio in tipoServicios"
              :key="`servicios-${tipoServicio.value}`"
              :ruta="`empresas-servicios/${tipoServicio.value.toLowerCase()}`"
              :texto="tipoServicio.label"
            />
          </menu-dropdown>
          <menu-item
            v-if="canAccessUsuariosComputed"
            ruta="usuarios"
            :es-activo="activeMenu === 'usuarios'"
            icon-css="fa-sharp fa-users"
            :texto="intl.i18n.t('menu.item.usuarios')"
            @click="setActiveMenu('usuarios')"
          >
          </menu-item>
          <menu-dropdown
            v-if="canAccessOperacionesEnergiaComputed || canAccessBorradoresOperacionComputed"
            :es-activo="activeMenu === 'operaciones'"
            icon-css="fa-solid fa-euro-sign"
            :texto="intl.i18n.t('menu.item.operaciones')"
            @click="setActiveMenu('operaciones')"
            @update-activo="activeMenu = 'operaciones'"
          >
            <menu-dropdown-item
              v-if="canAccessOperacionesEnergiaComputed"
              v-for="tipoServicio in tipoServicios"
              :key="`operaciones-${tipoServicio.value}`"
              :ruta="`operaciones/${tipoServicio.value.toLowerCase()}`"
              :texto="tipoServicio.label"
            />
            <div v-if="canAccessImportacionesOperacionesEnergiaComputed" class="dropdown-divider"></div>
            <menu-dropdown-item
              v-if="canAccessImportacionesOperacionesEnergiaComputed"
              ruta="operaciones/importaciones"
              :texto="intl.i18n.t('menu.item.importaciones')"
            />
            <div v-if="canAccessOperacionesEnergiaComputed && canAccessBorradoresOperacionComputed" class="dropdown-divider"></div>
            <menu-dropdown-item
              v-if="canAccessBorradoresOperacionComputed"
              v-for="tipoServicio in tipoServicios"
              :key="`borradores-operacion-${tipoServicio.value}`"
              :ruta="`borradores-operacion/${tipoServicio.value.toLowerCase()}`"
              :texto="`${intl.i18n.t('menu.item.borrador')} ${tipoServicio.label}`"
            />
          </menu-dropdown>
          <menu-item
            v-if="canAccessClientesComputed"
            ruta="clientes"
            :es-activo="activeMenu === 'clientes'"
            icon-css="fa-regular fa-user-group"
            :texto="intl.i18n.t('menu.item.clientes')"
            @click="setActiveMenu('clientes')"
          >
          </menu-item>
          <menu-dropdown 
            v-if="canAccessEmpresasAgentesComputed" 
            :es-activo="activeMenu === 'empresas'" 
            icon-css="fa-regular fa-buildings"
            :texto="intl.i18n.t('menu.item.empresas')" 
            @click="setActiveMenu('empresas')" 
            @update-activo="activeMenu = 'empresas'">

            <menu-dropdown-item 
              v-for="tipoEmpresaAgente in tipoEmpresaAgentes" :key="`empresas-agentes-${tipoEmpresaAgente.value}`"
              :ruta="`empresas-agentes/${tipoEmpresaAgente.value.toLowerCase()}`" 
              :texto="tipoEmpresaAgente.label" />
            <div v-if="canAccessEmpresasAgentesComputed" class="dropdown-divider"></div>
            <menu-dropdown-item 
              v-if="canAccessEmpresasAgentesComputed"
              ruta="empresas-agentes/pendientes-validacion" 
              :texto="intl.i18n.t('menu.item.pendientes-validacion')" />
            <div v-if="canAccessMarcosComisionesComputed" class="dropdown-divider"></div>
            <menu-dropdown-item 
              v-if="canAccessMarcosComisionesComputed" 
              ruta="marcos-comisiones" 
              :texto="intl.i18n.t('menu.item.marcos-comisiones')" />
          </menu-dropdown>
          <menu-item
            v-if="canAccessContactosLeadComputed"
            ruta="contactos-lead"
            :es-activo="activeMenu === 'contactos-lead'"
            icon-css="fa-regular fa-head-side-headphones"
            :texto="intl.i18n.t('menu.item.contactos-lead')"
            @click="setActiveMenu('contactos-lead')"
          >
          </menu-item>
          <menu-item
            v-if="canAccessComunicadosComputed"
            ruta="comunicados"
            :es-activo="activeMenu === 'comunicados'"
            icon-css="fa-regular fa-bullhorn"
            :texto="intl.i18n.t('menu.item.comunicados')"
            @click="setActiveMenu('comunicados')"
          >
          </menu-item>
        </ul>
        <ul class="navbar-nav ms-auto menu-usuario">
          <MenuItemNotificaciones
            claseCss="notificaciones"
            :esActivo="activeMenu === 'notificaciones'"
            :texto="intl.i18n.t('menu.item.notificaciones')"
            :numNotificaciones="numNotificacionesSinLeer"
            @click="$emit('toggle-notificaciones')"
          >
          </MenuItemNotificaciones>
          <menu-dropdown clase-css="usuario" :texto="auth.userInfo?.username" @update-activo="activeMenu = 'usuario'">
            <menu-dropdown-item ruta="#" @click="logout" :texto="intl.i18n.t('shared.ui.buttons.logout')" />
          </menu-dropdown>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script setup lang="ts">
import { useAuthentication } from "@services/auth";
import MenuLogo from "@/components/menu/MenuLogo.vue";
import MenuItem from "@/components/menu/MenuItem.vue";
import MenuDropdown from "@/components/menu/MenuDropdown.vue";
import MenuDropdownItem from "@/components/menu/MenuDropdownItem.vue";
import { useIntl } from "@/.shared/services/i18n";
import { computed, inject, onMounted, ref } from "vue";
import { TipoEmpresaServiciosEnum } from "@/.shared/.api";
import { useRoute } from "vue-router";
import { usePermissionCheckers } from "@/services/auth/permission-checkers-bo";
import MenuItemNotificaciones from "@/components/menu/MenuItemNotificaciones.vue";

const auth = useAuthentication();
const permissionCheckers = usePermissionCheckers();
const intl = useIntl();
const route = useRoute();
const activeMenu = ref<string>("");

const numNotificacionesSinLeer = inject<number>("numNotificacionesSinLeer");

// Función para determinar el menú activo según la ruta
const determineActiveMenu = () => {
  const path = route.path;
  if (path.includes("soporte")) return "soporte";
  if (path.includes("facturas")) return "facturas";
  if (path.includes("servicios")) return "servicios";
  if (path.includes("usuarios")) return "usuarios";
  if (path.includes("operaciones")) return "operaciones";
  if (path.includes("clientes")) return "clientes";
  if (path.includes("empresas")) return "empresas";
  if (path.includes("marcos-comisiones")) return "marcos-comisiones";
  if (path.includes("notificaciones")) return "notificaciones";
  if (path.includes("borradores-operacion")) return "borradores-operacion";
  if (path.includes("contactos-lead")) return "contactos-lead";
  if (path.includes("comunicados")) return "comunicados";
  return "";
};

// Inicializa el menú activo en función de la ruta
onMounted(() => {
  activeMenu.value = determineActiveMenu();
});

function logout() {
  auth.logout(import.meta.env.VITE_BASE_URL);
}

const canAccessFacturasComputed = computed(() => permissionCheckers.canAccessFacturas());
const canAccessSoporteComputed = computed(() => permissionCheckers.canAccessSoporte());
const canAccessUsuariosComputed = computed(() => permissionCheckers.canAccessUsuarios());
const canAccessOperacionesEnergiaComputed = computed(() => permissionCheckers.canAccessOperacionesEnergia());
const canAccessImportacionesOperacionesEnergiaComputed = computed(() => permissionCheckers.canAccessImportacionesOperacionesEnergia());
const canAccessClientesComputed = computed(() => permissionCheckers.canAccessClientes());
const canAccessEmpresasServiciosComputed = computed(() => permissionCheckers.canAccessEmpresasServicios());
const canAccessEmpresasAgentesComputed = computed(() => permissionCheckers.canAccessEmpresasAgentes());
const canAccessMarcosComisionesComputed = computed(() => permissionCheckers.canAccessMarcosComisiones());
const canAccessBorradoresOperacionComputed = computed(() => permissionCheckers.canAccessBorradoresOperacion());
const canAccessContactosLeadComputed = computed(() => permissionCheckers.canAccessContactosLead());
const canAccessComunicadosComputed = computed(() => permissionCheckers.canAccessComunicados());

const tipoServicios = computed(() => {
  return Object.values(TipoEmpresaServiciosEnum).map((tipo) => ({
    value: tipo,
    label: intl.i18n.t(`empresas_de_servicio.tipo.${tipo}`),
  }));
});

const tipoEmpresaAgentes = computed(() => {
  return Object.values(["COLABORADORES", "INMOBILIARIAS"]).map((tipo) => ({
    value: tipo,
    label: intl.i18n.t(`empresas_de_agentes.tipo.${tipo}`),
  }));
});

const setActiveMenu = (menu: string) => {
  activeMenu.value = menu;
};
</script>

<style scoped lang="scss">

.navbar {
  margin: var(--spacing-0) var(--spacing-sm) 20px;
  border-radius: 0 0 10px 10px;
  background:
    radial-gradient(circle at 3% 50%, rgba(26, 130, 110, 0.6) 0%, transparent 12%),
    radial-gradient(ellipse at 92% 90%, rgba(14, 107, 140, 0.85) 0%, transparent 45%), var(--background-primary-default);
  padding: var(--spacing-0);
  min-height: 60px;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.3) !important;
}

@media (max-width: 991px) {
  .navbar {
    background-position: center;
  }

  .navbar-collapse.collapse .nav-link {
    padding: var(--spacing-md) var(--spacing-0);
  }
}

@media (min-width: 1600px) {
  .navbar-expand-lg .navbar-collapse {
    margin-left: var(--spacing-lg);
  }

  .navbar-expand-lg .navbar-nav .nav-link,
  .navbar-text {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    gap: var(--spacing-2xs);
    align-items: center;
    min-height: 70px;
  }

  /*FIX MENÚ USUARIO*/
  .menu-usuario .dropdown-menu {
    right: 0;
    left: auto;
  }
}
</style>
